import { combineReducers } from 'redux';

import deviceReducer from './device';
import osReducer from './os';

const reducers = {
  device: deviceReducer,
  os: osReducer,
};

export default combineReducers(reducers);
